// ============================================
// 3D 侧设备联动 Hook（阶段3｜3.1/3.2）
// 订阅 deviceDataStore 选中事件（selectedDeviceId + deviceActionTick）：
//  1) 3D 点击模型（有 deviceId）→ selectDevice → 本 hook 把对应 3D 模型选中（高亮）+（focus 时）镜头定位
//  2) 2D 设备表格/联动动作 → selectDevice → 同上（2D 驱动 3D）
// SceneEditor 挂载。
// ============================================

import { useEffect } from 'react';
import { message } from 'antd';
import { useDeviceDataStore } from '../stores/deviceDataStore';
import useSceneStore from '../stores/sceneStore';
import useSelectionStore from '../stores/selectionStore';
import { cameraControlsRegistry } from '../stores/cameraControlsStore';

export function useDeviceLink3D() {
  useEffect(() => {
    let lastTick = -1;
    let lastId: string | null = null;

    const unsub = useDeviceDataStore.subscribe((s) => {
      const tick = s.deviceActionTick;
      const deviceId = s.selectedDeviceId;
      // 仅在选中动作变化时处理（同值重复点击也触发）
      if (tick === lastTick && deviceId === lastId) return;
      lastTick = tick;
      lastId = deviceId;

      if (!deviceId) return;
      const model = useSceneStore.getState().models.find((m) => m.deviceId === deviceId);
      if (!model) {
        // 用户可诊断性：3D 无绑定该设备的模型（阶段5 绑定 UI 可为模型配置设备）
        message.info('3D 场景中未找到绑定该设备的模型（可在模型属性「设备联动」中绑定）');
        return;
      }
      // 高亮（走 selection → applyHighlight → emissive 仲裁器）
      useSelectionStore.getState().select(model.id);
      // locate 动作带镜头定位；highlight/linkGlobal 不打扰视角
      if (s.selectedDeviceFocus) {
        // 2026-08-26｜演示优化：air8000w（绑定水体的设备）点击 → 高空俯视水池/工厂全景；
        // 其余设备保持聚焦选中模型（相机拉近模型）
        if (deviceId === '864793080088193' && cameraControlsRegistry.flyToPosition) {
          cameraControlsRegistry.flyToPosition([-100, 60, -110], [-81, -11, -175]);
        } else {
          cameraControlsRegistry.focusSelected?.();
        }
      } else {
        // demand 模式（联动预览/发布页）：高亮变化需主动请求重绘
        cameraControlsRegistry.requestRender?.();
      }
    });

    return unsub;
  }, []);
}